import React, { useContext, useEffect, useState } from 'react'
import antMessage from '../../../utils/extend/AntdNotification';
import systemConfig from '../../../config/systematic';
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Switch, Table, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import WebUniversalReport, { WUExtendPropsType } from '../../system/WebUniversalReport';
import dayjs from 'dayjs';
import { render } from '@testing-library/react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
const { RangePicker } = DatePicker;

export default function MembershipTransactionDetails() {
    let wmService: any = systemConfig.wmService;
    const [form] = Form.useForm();
    const form1 = Form.useForm()[0];
    const [rows, setRows] = useState<Array<any>>([]);
    const [branchStoreData, setBranchStoreData] = useState<any>();
    const [membershipTransactionTypeData, setMembershipTransactionTypeData] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [memoOpen, setMemoOpen] = useState<boolean>(false);
    const [memoData, setMemoData] = useState<any>();

    const [initValues, setInitValues] = useState<any>();
    // membershipTransactionTypeIds
    /** 表头内容 */
    let columnsHead: Array<any> = [
        {
            title: "会员号",
            dataIndex: "membership",
            render: (text: any) => {
                return <>{text.id}</>
            }
        },

        {
            title: "姓名",
            dataIndex: "membershipName",
        },
        {
            title: "手机号",
            dataIndex: "contactNumber",
        },
        {
            title: "首充门店",
            dataIndex: "firstBranchStoreName",
        },
        {
            title: "交易单号",
            dataIndex: "id",
        },
        {
            title: "实收",
            dataIndex: "balanceChange",
        },
        {
            title: "赠送",
            dataIndex: "giftsChange",
        },
        {
            title: "积分",
            dataIndex: "pointsChange",
            render: (text: any, record: any) => {

                return <>{`${record.pointsChange > 0 ? record.pointsChange : ""}${record.consumptionpointsChange < 0 ? `;${record.consumptionpointsChange}(-${record.pointsRedeemAmount})` : ""}`}</>
            }
        },
        {
            title: "交易时间",
            dataIndex: "successfulDate",
            render: (text: any, record: any) => { return <>{dayjs(text).format("YYYY-MM-DD")}</> }
        },
        {
            title: "合计",
            dataIndex: "consumption",
        },
        {
            title: "余额",
            dataIndex: "currentBalance",
            render: (text: any, record: any) => {
                return <>{record.currentBalance + record.currentGifts}</>
            }
        },
        {
            title: "操作门店",
            dataIndex: "branchStoreName",
        },

        {
            title: "交易类型",
            dataIndex: "membershipTransactionTypeName",
        },
        {
            title: "备注",
            dataIndex: "remarks",
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={"点击修改备注"}>{
                <div onClick={() => openMemo(record)}>{text ? text : <span >.</span>}</div>
            }</Tooltip>
        },
        {
            title: '打印',
            dataIndex: 'successfulDate',
            render: (text: any, record: any) => {
                return <Button onClick={() => printMembership(record)}>打印</Button>
            }
        },

        // 交易类型
    ]
    const printMembership = (apiData: any) => {

        fetchApi.GET(wmService, {
            apiId: "membershipTransactionDetails",
            apiExtend: 'printMembership',
            apiData: {
                id: apiData.id,
                branchStoreId: apiData.shopId
            }
        }).then((res) => {

            if (res.success) {
                antMessage("success", "打印命令已发送")

            }
        }).catch((err) => {
            antMessage("error", "命令发送失败", JSON.stringify(err))

        })
    }
    useEffect(() => {
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "branchStore",
                apiExtend: 'showListManage'
            }).then(res => {

                setBranchStoreData(res.data)
            })
            fetchApi.GET(wmService, {
                apiId: "generalData",
                apiExtend: 'bms',
                apiData: {
                    apiId: 'generalData',
                    apiExtend: 'showLists',
                    apiVariable: "membershipTransaction"

                }
            }).then(res => {
                if (res.success) {
                    const { membershipTransaction } = res.data;
                    setMembershipTransactionTypeData(membershipTransaction)

                    // setWxAccountWxPayData(res.data);
                }
            })
            // fetchApi.GET(bmService,
            //   {
            //     apiId: 'generalData',
            //     apiVariable: 'MembershipStatuses',
            //     apiExtend: 'showLists'
            //   }).then(res => {
            //     if (res.success) {
            //     //   const { caCoMonStatus } = res.data
            //     //   setCaCoMonStatus(caCoMonStatus);
            //     }
            //   })

            // 
        }
        fetchData()

    }, []);
    const openMemo = (record: any) => {

        setMemoOpen(true)
        setMemoData({ id: record.id })
        form1.setFieldsValue({ "remarks": record?.remarks })

    }
    const onChangeMemo = (record: any) => {
        form1.validateFields()
            .then((values: any) => {

                fetchApi.PUT(wmService, {
                    apiId: "membershipTransactionDetails",
                    apiExtend: "updateOne",
                    apiVariable: memoData.id,
                    apiData: {
                        columnName: "remarks",
                        value: values.remarks,


                    }
                }).then((res) => {
                    setMemoOpen(false)
                    setInitValues({ ...initValues, forcedRefresh: true })


                }).catch((err) => {
                    setMemoOpen(false)
                    antMessage("success", JSON.stringify(err))

                })

            }).catch((err) => {
                antMessage('warning', "无法通过数据校验", "请输入所需数据")

            })



    }

    const onFinish = () => {
        setIsLoading(true)
        form.validateFields()
            .then(async (values: any) => {
                setInitValues({
                    ...values,
                    shopIds: values.brandStoreIds,
                })
                setIsLoading(false)
            })
            .catch((err) => {
                setIsLoading(false)

                antMessage("error", "无法通过数据校验", "请输入所需数据")

            })





    }
    let extendProps: WUExtendPropsType = {
        apiId: 'membership',
        apiExtend: "membershipTransactionDetails",
        columns: columnsHead,
        pagination: true,
        values: initValues,
        isDownloadExcel: true,
        printType: "purchaseOrderPrint",
        typeProducts: "purchaseProducts",
        printApi: "purchaseOrder",
        showOperation: false,
        showPrint: false,
    };
    return (
        <>
            {/* <BranchStoreList setDeptData={setDeptData} setSbData={setSbData} form={form}></BranchStoreList> */}
            <Form
                form={form}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={6}>
                        <Form.Item
                            label="门店"
                            name="brandStoreIds"
                        >
                            <Select
                                mode="multiple"
                                fieldNames={{ value: "id", label: "branchStoreName" }}
                                allowClear
                                placeholder="门店"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                                options={branchStoreData}
                            >
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            label="交易类型"
                            name="membershipTransactionTypeIds"
                        >
                            <Select
                                mode="multiple"
                                fieldNames={{ value: "id", label: "name" }}
                                allowClear
                                placeholder="交易类型"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                                options={membershipTransactionTypeData}
                            >
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item

                            label="消费日期"
                            name="consumptionTime"
                        >
                            <RangePicker

                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            label="手机号码"
                            name="contactNumber"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item >
                            <Space>
                                <Button loading={isLoading} htmlType="submit">
                                    统计
                                </Button >
                                {/* <Button onClick={() => DownloadExcel(rows, "makeDept", { date: form.getFieldValue("chooseTime"), sbName, userName, caCoMonStatusName })}>下载EXCEL文件</Button> */}

                                {/* purContrast */}
                            </Space>
                        </Form.Item>
                    </Col>


                </Row>

            </Form>
            {memoOpen ? <AntDraggableModal
                title={"修改备注"}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={onChangeMemo}
                onCancel={() => setMemoOpen(false)}
                closable={false}
                maskClosable={false}
            >
                <Form

                    form={form1}
                    name="Edit"
                    onFinish={onChangeMemo}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            onChangeMemo(e)
                        }
                    }}>


                    <Form.Item
                        label="备注"
                        name="remarks"
                        rules={[{ required: false, message: '请输入备注!' }]}>
                        <Input />
                    </Form.Item>



                </Form>
            </AntDraggableModal> : null}
            <WebUniversalReport props={extendProps}></WebUniversalReport>
        </>
    )
}
